// @ts-check

import "../jsdoc-types"
import classNames from 'classnames';
import {RichText} from "./RichText";

/**
 * @param {Object} props
 * @param {GridCellEntry} props.cdaEntry
 */
export function GridCell({cdaEntry}) {
    const {width = "1", content} = cdaEntry.fields;

    return (
        <div className={classNames("service-page-grid-cell", `--width-${width}`)}
        >
            {content && <RichText cdaEntry={content}/>}
        </div>
    );
}
